"use client";
import React, { useEffect, useState } from "react";
import { get_tool_cat_api } from "../Config/API";
import { NavLink, useParams, useNavigate, useLocation } from "react-router-dom";
import select from "../Assets/select.png";
import machine from "../Assets/images/machine.png";
import toolsImg from "../../src/Assets/images/drilling.png";

// export default function Dashboard() {
//   const [categories, setCategories] = useState({
//     data: [],
//     loading: false,
//   });
//   const [type, setType] = useState("");
//   const navigate = useNavigate();
//   const location = useLocation();
//   // console.log("location 1", location);

//   const { tool_type } = useParams();
//   // console.log("tool_type",tool_type)
//   //  console.log("type",type)
//   useEffect(() => {
//     setCategories({ data: [], loading: true });

//     if (tool_type && tool_type != "" && tool_type !== "dashboard") {
//       let payload = {
//         uuid: tool_type,
//       };
//       get_tool_cat_api(payload)
//         .then((res) => {
//           setCategories({ data: res.data.data, loading: false });
//           setType(res.data.tool_type_name);
//         })
//         .catch((er) => {
//           setCategories({ data: [], loading: false });
//         });
//     }
//   }, [tool_type]);

//   return (
//     <div className="px-10 h-full overflow-y-auto pb-[10%] ">
//       {categories.data.length == 0 ? (
//         <>
//           {categories.data.length == 0 && categories.loading == false ? (
//             <div>
//               <div className="text-center">
//                 <img src={machine} className="emptyToolCat" alt="" />
//                 <h1 className="catLable mt-5 text-3xl font-semibold ">
//                   Please select Tool Category
//                 </h1>
//               </div>
//             </div>
//           ) : (
//             <div className="text-center ">
//               <svg
//                 aria-hidden="true"
//                 className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
//                 viewBox="0 0 100 101"
//                 fill="none"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <path
//                   d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//                   fill="currentColor"
//                 />
//                 <path
//                   d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//                   fill="currentFill"
//                 />
//               </svg>
//               <span className="sr-only">Loading...</span>
//             </div>
//           )}
//         </>
//       ) : (
        
       
//         <div>
//           <div className="text-base p-6 border-b border-gray-400 ">
//             <span className="text-base text-main-color">{type}</span>
//           </div>

//           <div className="grid grid-cols-3 gap-5 mt-10">
//             {categories.data?.map((cat, index) => (
//               <div
//                 className="text-center p-5 rounded-md cursor-pointer gridboxshadow"
//                 key={index}
//                 onClick={() => {
//                   navigate(`/${tool_type}/${cat.uuid}`, {
//                     state: {
//                       path_arr: [type, cat.description],
//                     },
//                   });
//                 }}
//               >
//                 {/* <NavLink to={
//                             {
//                                 pathname: `/${tool_type}/${cat.uuid}`,
//                                 state: {description:"cat.description" }
//                               }
//                         }><h2 className="mb-3 text-lg"> {cat.description}</h2></NavLink> */}

//                 <div className="toolcatimg">
//                   <img src={toolsImg} width={112} height={31} alt="" />
//                 </div>
//                 <h2 className="mb-3 text-lg mt-5"> {cat.description}</h2>
//                 {/* <p> </p> */}
//               </div>
//             ))}
//           </div>
//         </div>

        
//       )}
//     </div>
//   );
// }

export default function Dashboard() {
  const [categories, setCategories] = useState({
    data: [],
    loading: false,
    norecords:false
  });
  const [type, setType] = useState("");
  const navigate = useNavigate();
  const { tool_type } = useParams();

  useEffect(() => {
    setCategories({ data: [], loading: true,norecords:false });

    if (tool_type && tool_type !== "" && tool_type !== "dashboard") {
      const payload = { uuid: tool_type };
      get_tool_cat_api(payload)
        .then((res) => {
             
           if(res?.data?.data?.length>0){
            setCategories({ data: res.data.data, loading: false ,norecords:false});
            setType(res.data.tool_type_name);
           }else{
            setCategories({ data: [], loading: false ,norecords:true });
            setType(res.data.tool_type_name);

           }
          
        })
        .catch(() => {
          setCategories({ data: [], loading: false ,norecords:false });
        });
    } else {
      setCategories({ data: [], loading: false ,norecords:false});
    }
  }, [tool_type]);

  return (
    <div className="px-10 h-full overflow-y-auto pb-[10%]">
      {categories.loading ? (
        <div className="text-center">
          <svg
            aria-hidden="true"
            className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      ) : categories.data.length === 0 ? (
        <div className="text-center">
          <img src={machine} className="emptyToolCat" alt="No categories available" />
          <h1 className="catLable mt-5 text-3xl font-semibold">
            {categories.norecords==true?`No records found`:"Please select Tool Category"}
          </h1>
        </div>
      ) : (
        <div>
          <div className="text-base p-6 border-b border-gray-400">
            <span className="text-base text-main-color">{type}</span>
          </div>

          <div className="grid grid-cols-3 gap-5 mt-10">
            {categories.data.map((cat, index) => (
              <div
                className="text-center p-5 rounded-md cursor-pointer gridboxshadow"
                key={index}
                onClick={() => {
                  navigate(`/${tool_type}/${cat.uuid}`, {
                    state: {
                      path_arr: [type, cat.description],
                    },
                  });
                }}
              >
                <div className="toolcatimg">
                  <img src={toolsImg} width={112} height={31} alt="Tool category" />
                </div>
                <h2 className="mb-3 text-lg mt-5">{cat.description}</h2>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

